<template>
  <BookCategoryLayout
    :category="category"
    :label="categoryLabel"
    :searcher="customSearcher || searcher"
    show-extra
    :publications="userPublications"
    :sort-strategy="sortStrategy"
    :custom-counter="customCounter"
    @change="filterChanged"
  />
</template>

<script>
import { mapGetters } from 'vuex';

import SessionStorageService from '@/services/SessionStorageService';
import ManagePublicationsStates from '@/enums/ManagePublicationsStatesEnum';
import SearchPublicationsFactory from '@/classes/factories/SearchPublicationsFactory';
import publicationUtils from '@/services/utils/publicationUtils';

import libraryViewScrollMixin from '@/components/mixins/libraryViewScrollMixin';

import BookCategoryLayout from '@/components/views/CategoryView/BookCategoryLayout.vue';
import isEmpty from 'lodash/isEmpty';

export default {
  name: 'CategoryView',
  components: { BookCategoryLayout },
  mixins: [libraryViewScrollMixin],
  props: {
    searcher: Object,
    publications: Array,
    sortStrategy: String,
    customCounter: [Number, String]
  },
  data() {
    return {
      isMounted: false,
      customSearcher: null
    };
  },
  computed: {
    ...mapGetters('LibraryStore', ['searchLibraryBooks']),
    isOffline() {
      return !this.$store.getters['ContextStore/isOnline'];
    },
    userPublications() {
      if (!this.isMounted) {
        return this.publications;
      }
      const refreshedPublications = this.searchLibraryBooks(
        this.customSearcher || this.searcher,
        this.customSearcher?.isCollectionIncluded ?? false
      );
      if (isEmpty(refreshedPublications) && this.isOffline) {
        return this.publications;
      }
      return refreshedPublications;
    },
    category() {
      const category =
        this.userPublications[0]?.category ??
        this.publications[0]?.category ??
        this.$route.params.name;
      return category;
    },
    categoryLabel() {
      return publicationUtils.getCategoryLocalizationKey(
        this.category,
        this.$t.bind(this)
      );
    }
  },
  async mounted() {
    await this.$store.dispatch('LibraryStore/reinitState', {
      managePublicationsState: ManagePublicationsStates.LIBRARY
    });
    await this.$store.dispatch('LibraryStore/loadPublicationCategoryInfo');

    if (this.publications?.length) {
      this.isMounted = true;
      return;
    }
    const currentLanguage = this.$store.getters[
      'ContextStore/currentLanguageGetter'
    ];
    let searcher = this.searcher;
    if (!this.searcher) {
      const builder = SearchPublicationsFactory.getSearcherBuilder();
      builder
        .setState(ManagePublicationsStates.LIBRARY)
        .setLanguage(currentLanguage)
        .setCategories([this.$route.params.name])
        .setFilter('');
      searcher = builder.build();
    }
    this.customSearcher = searcher;
    this.isMounted = true;
  },
  destroyed() {
    SessionStorageService.set(
      'previousRoute',
      this.$store.getters['ContextStore/getPreviousNotBookRoute']
    );
  },
  methods: {
    filterChanged(searcher) {
      this.customSearcher = searcher;
      this.$store.commit('LibraryStore/setCategorySearcher', searcher);
    }
  }
};
</script>

<style lang="less"></style>
